import { render, staticRenderFns } from "./ColmenaDetail.vue?vue&type=template&id=7f29d7ac&"
import script from "./ColmenaDetail.vue?vue&type=script&lang=js&"
export * from "./ColmenaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports